export default {
  en: {
    addAgent: 'Add Agent',
    filterByName: 'Filter by Name',
    agentName: 'Agent Name',
    add: 'Add',
    added: 'Added',
    save: 'Save',
    cancel: 'Cancel'
  },
  th: {
    addAgent: 'เพิ่มตัวแทน',
    filterByName: 'ค้นหาด้วยชื่อ',
    agentName: 'ชื่อตัวแทน',
    add: 'เพิ่ม',
    added: 'เพิ่มแล้ว',
    save: 'บันทึก',
    cancel: 'ยกเลิก'
  }
}
